export enum AuthRouteName {
    Login = 'login'
}
